<template>
  <a-card :bordered='false'>
    <div class='table-page-search-wrapper'>
      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter='12'>
          <a-col :md='6' :sm='8'>
            <a-form-item :label="'日期'">
              <a-range-picker v-model='queryParam.sendTime' format='YYYY-MM-DD' style='width: 100%;' />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="10">
            <a-form-item :label="'主产品'">
              <a-select mode='multiple' v-model='queryParam.mainAppSsids' :max-tag-count="2">
                <a-select-option v-for='item in mainAppList' :key='item.appssid' :value='item.appssid'>
                  {{ item.appName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          
        </a-row>
        <a-row :gutter='12'>
          <a-col :span='6'>
            <a-button type='primary' @click='searchQuery' icon='search'>{{ $t('search') }}</a-button>
            <a-button type='primary' @click='searchReset' icon='reload' style='margin-left: 8px'>{{ $t('reset') }}</a-button>
            <a-button type='primary' @click="downLoadData()" icon='download' style='margin-left: 8px'>{{ $t('exportFile') }}</a-button>
          </a-col>
        </a-row>
      </a-form>

      <!-- 主表格：用 index 做 key，彻底杜绝重复 -->
      <a-table
        ref='table'
        row-key="index"
        size='middle'
        :columns='columns'
        :dataSource="(dataSource || []).map((item,index)=>({...item,index}))"
        :pagination='false'
        :loading='loading'
        bordered
        :scroll="{ x: 'max-content' }"
        @change='handleTableChange'
      />
      <div style='margin-top: 15px; text-align: right;'>
          <v-pagination
            v-if='total'
            :page-num='form.pageNum'
            :page-size='form.pageSize'
            :total='total'
            @change='handleTableChange' />
        </div>
    </div>
  </a-card>
</template>

<script>
import { filterObj } from '@/utils/util'
import { repaymentReportForQuota, getApplistExcludingSubApp } from '@/webpublicapi/order'
import moment from 'moment'
import { exportFileByPost } from '@/api/exportFile'

const I18N_KEY = {
  ORDER: 'order.',
  CUSTOMER: 'customer.',
  APPROVAL: 'approval.'
}

export default {
  data() {
    return {
      I18N_KEY,
      mainAppList: [],
      form: { pageNum: 1, pageSize: 10 },
      total: 0,
      dataSource: [],
      queryParam: { sendTime: [], mainAppSsids: [] },
      loading: false
    }
  },
  computed: {
    columns() {
      return [
        { title: '申请金额', align: 'center', dataIndex: 'applyAmt' },
        { title: '申请笔数', align: 'center', dataIndex: 'orderNum' },
        { title: '今日到期笔数', align: 'center', dataIndex: 'endDateOrderAgoNum' },
        { title: '今日到期未结清笔数', align: 'center', dataIndex: 'endDateUnSettleOrderAgoNum' },
        { title: '今日未结清率', align: 'center', dataIndex: 'endDateUnSettleOrderAgoNumRate' },
        { title: '实际放款金额/已还款金额', align: 'center', dataIndex: 'endDateUnSettleOrderExpireAmountRate' }
      ]
    }
  },
  created() {
    this.loadSelectData()
    this.loadData()
  },
  methods: {
    formatNumber(v) { return v == null ? 0 : Number(v).toLocaleString() },
    loadSelectData() {
      getApplistExcludingSubApp().then(res => res.data && (this.mainAppList = res.data))
    },
    searchQuery() { this.loadData() },
    loadData() {
      const p = this.getQueryParams()
      if (!p) return
      this.loading = true
      repaymentReportForQuota(p).then(res => {
        try {
          if (res.code === 1000) {
            this.loading = false;
            this.dataSource = res.data.rows || []
            this.total = res.data.total || 0
            this.$message.success(res.msg)
          } else {
            this.loading = false;
            this.total = 0
            this.dataSource = []
            this.$message.info(res.msg)
          }
        } catch (error) {
          this.$message.error(error.msg)
        } finally {
          this.loading = false;
        }
        
      })
    },
    transformTime: t => moment(t).format('YYYY-MM-DD'),
    getQueryParams() {
      const { sendTime } = this.queryParam
      const d = {
        ...this.queryParam,
        queryStartTime: sendTime?.length ? this.transformTime(sendTime[0]) : null,
        queryEndTime: sendTime?.length ? this.transformTime(sendTime[1]) : null
      }
      delete d.sendTime
      d.pageNum = this.form.pageNum
      d.pageSize = this.form.pageSize
      return filterObj(d)
    },
    async downLoadData() {
      const p = this.getQueryParams()
      delete p.pageNum; delete p.pageSize
      this.loading = true
      try { await exportFileByPost('/api/web/webpublic/repayNotLoan/excel', p, "产品复贷详情报表.xlsx") }
      catch (e) { this.$message.error(e.message) }
      finally { this.loading = false }
    },
    handleTableChange(pn, ps) { this.form.pageNum = pn; this.form.pageSize = ps; this.loadData() },
    searchReset() {
      this.queryParam = { sendTime: [], mainAppSsids: [] }
      this.form = { pageNum: 1, pageSize: 10 }
      this.loadData()
    }
  }
}
</script>
<style lang='less' scoped>
@import "~@/assets/less/common.less";
</style>